module.exports = __webpack_public_path__ + "img/72.2ed47e15.jpg";